export default {
  list: []
}
